module["exports"] = [
  "#{city_prefix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_au_ocker/address/city.js
// module id = 1060
// module chunks = 0